import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const getOffset = () => {
    const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    return header + 36;
};

(function () {
    const sections = document.querySelectorAll('.thesis-section');
    const tabs = document.querySelectorAll('.thesis-tabs');

    if (!sections.length || !tabs.length) return;

    const setActive = (id) => {
        tabs.forEach((tab) => {
            tab.classList.toggle('active', tab.dataset.target === id);
        });
    };

    sections.forEach((section) => {
        ScrollTrigger.create({
            trigger: section,
            start: () => `top ${getOffset()}px`,
            end: () => `bottom ${getOffset()}px`,
            onEnter: () => setActive(section.id),
            onEnterBack: () => setActive(section.id),
        });
    });

    tabs.forEach((tab) => {
        tab.addEventListener('click', function () {
            const target = this.dataset.target;

            const rootStyles = getComputedStyle(document.documentElement);
            const offsetValue = (parseFloat(rootStyles.getPropertyValue('--header-height')) || 0) + 30;

            gsap.to(window, {
                duration: 0.6,
                scrollTo: {
                    y: '#' + target,
                    offsetY: offsetValue,
                },
                ease: 'power2.inOut',
            });
        });
    });
})();
